<template>
  <div class="lotto-result">
    <div class="result-desc">
      <div class="result-title">
        <slot name="drwNo"> {{ lottoResult.drwNo }} 회차</slot>
        ({{ getDateFormat(lottoResult.drwNoDate, "yyyy.MM.dd.") }})
      </div>
    </div>
    <div class="result-title">당첨번호</div>
    <div class="result-area">
      <div class="ball-wrapper">
        <div
          v-for="(number, index) in drwtNumbers"
          :key="index"
          :class="getColorClass(number)"
          class="ball"
        >
          <div class="number">{{ number }}</div>
        </div>
        <div class="bonus-indicator">+</div>
        <div :class="getColorClass(lottoResult.bnusNo)" class="ball">
          <div class="number">{{ lottoResult.bnusNo }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import UtilMixin from "@/common/mixins/UtilMixin";
import { LottoResultResponse } from "@/lotto/class/index";

export default defineComponent({
  name: "LottoResult",
  props: {
    lottoResult: {
      type: LottoResultResponse,
      required: true,
      default: () => new LottoResultResponse(),
    },
  },
  setup() {
    return {};
  },

  data() {
    return {
      //
    };
  },
  mixins: [UtilMixin],
  computed: {
    drwtNumbers(): number[] {
      return [
        this.lottoResult!.drwtNo1,
        this.lottoResult!.drwtNo2,
        this.lottoResult!.drwtNo3,
        this.lottoResult!.drwtNo4,
        this.lottoResult!.drwtNo5,
        this.lottoResult?.drwtNo6,
        // this.lottoResult!.bnusNo,
      ];
    },
  },
  methods: {
    /**
     * 숫자 범위에 따라 색상을 반환하는 함수
     */
    getColorClass(number: number) {
      if (number >= 1 && number <= 9) return "bg-yellow-400";
      if (number >= 10 && number <= 19) return "bg-blue-400";
      if (number >= 20 && number <= 29) return "bg-red-400";
      if (number >= 30 && number <= 39) return "bg-gray-400";
      if (number >= 40 && number <= 45) return "bg-green-400";
      return "bg-black-400?"; // 예외처리
    },
  },
  created() {
    console.log("lottoResult : ", this.lottoResult);
  },
});
</script>
